import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { withFeature } from 'flagged';
import { Landing } from '../../ui/CreatePatient/Landing.js';
import { routes } from '../../config';
import { getConfig } from './createPatientLandingConfig';
import headerCancelModal from '../../actions/headerCancelModalAction';
import { getLabelsForFields } from '../../utils/labelHelper';

const CreatePatientLanding = ({ rendering }) => {
  const labels = getLabelsForFields(rendering.fields);
  const dispatch = useDispatch();
  const history = useHistory();
  const modalTrigger = useSelector(
    (payload) => payload.headerCancelModal,
  );

  const redirectToHome = () => {
    history.push(routes.dpx.home);
  };

  useEffect(() => {
    if (modalTrigger) {
      dispatch(headerCancelModal(false));
      redirectToHome();
    }
  }, [modalTrigger]);

  return (
    <div id="main-content">
      <Landing config={getConfig()} labels={labels} data={{}} />
    </div>
  );
};

export default withFeature('featureEnabler/createPatient')(
  CreatePatientLanding,
);
